import React, { useEffect, useState } from "react";
import ImageCarousal from "../Components/ImageCarousal";
import { Getdata } from "../helpers/api.service";
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../Components/common/Breadcrums";

const ExtracurricularList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { description } = location.state || {};
  const { title } = useParams();
  let [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/${title?.toLowerCase()}/fetch/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
        }
        setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log(data, "--Harshal");

  return (
    <div className="py-2">
      {/* Breadcrumbs */}
      <div className="text-start max-w-7xl px-4 mx-auto font-medium mb-5 mt-8">
        <Breadcrums
          pages={[
            { title: "Extracurricular", link: " " },
            { title: title },
          ]}
        />
      </div>

      {/* Image Carousel */}
      <ImageCarousal images={images} title={title} />

      {/* Content Section */}
      <div className="p-4 sm:p-6 space-y-6 text-left">
        <div className="max-w-6xl mx-auto text-center px-2">
          <h2 className="text-2xl sm:text-3xl md:text-4xl text-black font-bold mb-5">
            {title}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-start text-gray-700 leading-relaxed">
            {description}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {data?.length > 0 &&
            data.map((item, index) => (
              <div
                key={index}
                className="bg-[#F9F5FF] border border-[#EAEAEA] rounded-lg overflow-hidden transition-transform hover:scale-[1.01] duration-200"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  onClick={() =>
                    navigate(`/extra-curricular-details/${item.title}`, {
                      state: { title },
                    })
                  }
                  className="w-full h-[200px] sm:h-[230px] object-cover cursor-pointer"
                />

                <div className="p-4 text-gray-800">
                  <h3 className="text-base sm:text-lg font-semibold mb-1 break-words">
                    {item.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-2 break-words">
                    {item?.brief}
                  </p>
                  <h3 className="text-xs sm:text-sm text-gray-400 font-normal">
                    {dayjs(item.createdAt).format("DD MMM YYYY")}
                  </h3>
                </div>
              </div>
            ))}
        </div>

        {/* No Data State */}
        {data?.length === 0 && (
          <div className="h-[50vh] flex items-center justify-center w-full">
            <h1 className="text-center text-gray-400 text-lg">No Data Found</h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExtracurricularList;
